import React, {useState, useEffect} from 'react'
import datas from '../../datas/Datas'
import './FindJob.css'
import JobCard from '../../components/Cards/JobCard'
import InputIcon from '../../../components/Form/InputIcon'
import Select from '../../../components/Form/Select'
import Modal from "../../../components/Modal"
import InputRadio from '../../../components/Form/InputRadio'
import Checkbox from '../../../components/Form/Checkbox'
import ButtonBlack from '../../../components/Buttons/ButtonBlack'
import search from "../../assets/searchIcon/search.svg"
import location from "../../assets/searchIcon/location.svg"
import category from "../../assets/searchIcon/category.svg"
import filter from "../../assets/searchIcon/filter.svg"
// import imageNotFound from "../../assets/Illustrations/findintelescope.png"
import ResultNotFound from "../../components/ResultNotFound"
// D:\stage 2024\MIRA2.0\front\src\app\plateform\assets\Illustrations\resultnotfound.png
import JobCardSkeleton from "../../components/Skeletons/JobCardSkeleton"
import back11 from '../../assets/images/49eddec5-17f2-4a0c-b7ca-5ece838b0848.jpg'
import SelectIcon from '../../../components/Form/SelectIcon'
import { motion } from 'framer-motion'
import { useDispatch, useSelector } from 'react-redux'
import { fetchJobs } from '../../../redux/jobSlice'
import { fetchCategoriesByType } from '../../../redux/categorySlice'
import Pagination from "../../components/Pagination"
import LayoutSwitcher from '../../components/LayoutSwitcher'
import AdvancedSearchModal from '../../components/Modals/AdvancedSearchModal'
import RowPagination from "../../components/Pagination"
import FlatChararacter from "./FlatChararacter"

const FindJob = () => {
  const [showModal, setshowModal] = useState(false)
  const [listStyle, setListStyle] = useState("md:grid-cols-1")
  const dispatch = useDispatch();
  const { jobs, loading, error } = useSelector((state) => state.job);
  // const dispatch = useDispatch();
  const { items: categories, status } = useSelector((state) => state.categories);

  useEffect(() => { 
      dispatch(fetchCategoriesByType("offer"));
  }, [dispatch]);

  const [filters, setFilters] = useState({
    keyword: '',
    localisation: '',
    secteur: '',
    contractType: [],
    experience: 'Tous',
    education: 'Tous',
    level: 'Tous',
    page: 1,
    limit: 10
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // Fonction pour gérer les changements de cases à cocher
  // const handleCheckboxChange = (name, value) => {
  //   setFilters((prev) => {
  //     const newValues = prev[name].includes(value)
  //       ? prev[name].filter((v) => v !== value) // Supprime si déjà sélectionné
  //       : [...prev[name], value]; 
  //     return { ...prev, [name]: newValues };
  //   }
  
  // Fonction pour gérer les changements de cases à cocher
const handleCheckboxChange = (value) => {
  setFilters((prev) => {
    const newValues = prev.contractType.includes(value)
      ? prev.contractType.filter((v) => v !== value) // Supprime si déjà sélectionné
      : [...prev.contractType, value]; // Ajoute si non sélectionné

    return { ...prev, contractType: newValues };
  });
};

  const handleSearch = () => {
    dispatch(fetchJobs(
      {
        location: filters.localisation,
        category: filters.category,
        keyword: filters.keyword,
        secteur: filters.secteur,
        contractType: filters.contractType,
        experience: filters.experience,
        education: filters.education,
        level: filters.level,
        page: 1,
        limit: 10,
      }
    ))
    setshowModal(false); // Ferme le modal après la recherche
  };

  const handlePageChange = (newPage) => {
    setFilters((prev) => ({
      ...prev,
      page: newPage+1,
    }));
  };

  useEffect(() => {

    dispatch(fetchJobs({
      location: filters.localisation,
      category: filters.category,
      keyword: filters.keyword,
      secteur: filters.secteur,
      contractType: filters.contractType,
      experience: filters.experience,
      education: filters.education,
      level: filters.level,
      page: filters.page,
      limit: 10,
    })); 
  }, [filters.page]); 
  
  return (
    <div className=''>
      <div className=" h-56 w-full px-6 lg:px-20 xl:px-40 py-8 object-cover bg-primary-purple "  >
      <FlatChararacter/>

        <div className="flex justify-between mb-10">
        <h5 className='font-semibold text-lg'>Emploi</h5>
        </div>
        <div className="bg-white rounded-lg shadow h-auto p-2">
          <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-2">
            <InputIcon name="keyword" value={filters.keyword} placeholder='Offre, poste, mot clé ...' noBorder={true} onChange={handleInputChange}/>
            <InputIcon className='hidden xl:block' value={filters.localisation} icon={location} name="localisation" placeholder='Localisation' noBorder={true} onChange={handleInputChange}/>
            <SelectIcon
            options={categories.map((cat) => ({
              value: cat.id,
              label: cat.name,
            }))}
            value={filters.secteur}
            className="hidden md:block"
            icon={category}
            name="secteur"
            placeholder="Sélectionner un secteur"
            noBorder={true}
            onChange={handleInputChange}
          />
            <div className="flex items-center gap-x-2 gap-y-2">
              <button 
                onClick={() => setshowModal(true)} 
                className=" h-full w-[58px] justify-center border border-[#E8E8E8] bg-[#FBFBFB] rounded-md flex gap-2 items-center">
                <img src={filter} alt="" />
                
              </button>
              <button onClick={()=>{
                dispatch(fetchJobs(
                  {
                    location: filters.localisation,
                    category: filters.category,
                    keyword: filters.keyword,
                    secteur: filters.secteur,
                    contractType: filters.contractType,
                    experience: filters.experience,
                    education: filters.education,
                    level: filters.level,
                    page: 1,
                    limit: 10,
                  }
                ))}
                } className="p-4 py-3 bg-black rounded-md text-white font-medium w-full">
                Rechercher
              </button>
            </div>
          </div>
        </div>

      </div>
      <div className="bg-white px-6 lg:px-20 xl:px-40 h-16 shadow-sm -6 py-3">
        <div className="flex justify-between items-center">
          <div className="flex gap-2 items-center"> 
          <span className="text-lg font-semibold"> {jobs?.total} Résultats </span>
          </div>

          <div className="flex gap-2 items-center"> 
          <span>Par page </span>
          <Select name="limit" className="w-40" options={["10", "15","30"]} mb='0' onChange={(e)=>setFilters({...filters, limit: e.target.value})}/> 
          
          <LayoutSwitcher setListStyle={setListStyle} listStyle={listStyle} />
          </div>
          
         
        </div>
      </div>
        {/* <div className="bg-white  px-6 lg:px-20 xl:px-40 h-16 shadow-sm   py-3">
            <div className="flex justify-between items-center ">
              <Select name="period" options={["Récent","Populaire"]} mb='0'/>
              <LayoutSwitcher setListStyle={setListStyle} listStyle={listStyle} />
            </div>
        </div>    */}
          
      <div className="flex-1 px-6 lg:px-20 xl:px-40  bg-primary-beige pt-6 pb-14">
        <div className="  py-3">
          <div className={'grid grid-cols-1 min-[1920px]:grid-cols-3  sm:grid-col-span-1 gap-6 ' + listStyle}>
          {
          loading  ?
            Array.from({ length: 6 }).map((_, index) => (
              <JobCardSkeleton key={index} />
            ))
         :
             ( (jobs?.total > 0 )
              ?
              jobs?.data?.map((item, index)=>{
                return ( 
                  <motion.div
                    initial={{ opacity: 0, y: 100 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -100 }}
                    transition={{ duration: 0.5 + index/10 }}
                    // key={job?._id}
                    >
                  <JobCard key={item.id} item={item} />
                  </motion.div>
                  )
                })
              :
              <ResultNotFound/>)
            }
           
        {/* } */}
          </div>
          <RowPagination
    currentPage={filters?.page || 1}
    setCurrentPage={handlePageChange}
    totalPages={jobs?.last_page }
    />
      </div>
      </div>
      {/* <hr/> */}
          

      <AdvancedSearchModal
      showModal={showModal}
      setshowModal={setshowModal}
      filters={filters}
      handleInputChange={handleInputChange}
      handleCheckboxChange={handleCheckboxChange}
      handleSearch={handleSearch}
      handleCancelFilter={()=>{setFilters({
        keyword: '',
        localisation: '',
        secteur: '',
        contractType: [],
        experience: 'Tous',
        education: 'Tous',
        level: 'Tous',
        page: 1,
        limit: 10
      })
      dispatch(fetchJobs(
        {
          keyword: '',
          location: '',
          secteur: '',
          contractType: [],
          experience: 'Tous',
          education: 'Tous',
          level: 'Tous',
          page: 1,
          limit: 10
        }
      ))
      setshowModal(false)
    }}
    />
    </div>
  )
}

export default FindJob